import PropTypes from 'prop-types';

import RichText from '../../../Core/RichText';

import { Wrapper, StyledContainer, Grid, Block } from './styles';

// * heading {Obj/Richtext} - Richtext node for the card headline
// * blocks {array} - array of data objs for each card / block

const OptimumProductCards = ({ className = '', data }) => {
  if (!data) return null;

  const {
    heading,
    subheading,
    cards,
    elements,
    sectionContainerHeading,
    sectionSubheading,
    backgroundColor,
  } = data;

  const cardItems = cards || elements;
  const header = heading || sectionContainerHeading;
  const subheader = subheading || sectionSubheading;

  return (
    <Wrapper backgroundColor={backgroundColor}>
      <StyledContainer
        className={`auto-margin ${className} ${!heading && 'small-padding'}`}
      >
        {header && <RichText document={header} />}
        {subheader && <RichText document={subheader} />}
        <Grid>
          {cardItems.map((block, index) => {
            const { id, backgroundColor: bgColor } = block;
            const style = !(index % 2) ? 'left' : 'right';
            return (
              <Block key={id} className={`${bgColor} ${style}`} data={block} />
            );
          })}
        </Grid>
      </StyledContainer>
    </Wrapper>
  );
};

OptimumProductCards.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape().isRequired,
};

export default OptimumProductCards;
